import { Skeleton } from '@/components/common/Skeleton';

type TradeConfirmationSkeletonProps = {
  numberOfLines?: number;
};

export const TradeConfirmationSkeleton = ({
  numberOfLines = 2,
}: TradeConfirmationSkeletonProps) => {
  return Array.from({ length: numberOfLines }).map((_, index) => (
    <Skeleton key={index} className="w-full h-[21px]" />
  ));
};
